/**
 * @typedef {('size2'|'size3'|'size4'|'size6'|'size8'|'size9'|'size10'|'size12')} ResponsiveWidth
 */
export const ResponsiveWidth = {
  Cols2: 'size2',
  Cols3: 'size3',
  Cols4: 'size4',
  Cols6: 'size6',
  Cols8: 'size8',
  Cols9: 'size9',
  Cols10: 'size10',
  Cols12: 'size12',
};
